import { Modal, Tooltip } from "antd";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faRotate, faXmark } from "@fortawesome/free-solid-svg-icons";

//APP
import { useDownloadResultado, useReprocessarOs } from "../../../../../../../../services/Laboratorio/MUTATIONS";

//COMPONENT
import ButtonCustom from "../../../../../../../../Components/ButtonCustom";
import { Box } from "../../../../../../../../Components/CustomUi/box";
import { Render } from "../../../../../../../../Components/CustomUi/render";
import { Warning } from "../../../../../../../../Components/CustomUi/warning";

interface Props {
    /** URL do arquivo processado (resultado da análise). */
    arquivo_processado_url: string
    cod: number
    cod_cliente: number
    propriedade_nome: string
    talhao_nome: string
    cod_calcario: number
    cod_calcario_propriedade: number
    /** Recarrega a lista após reprocessar. */
    refetch?: Function
    /** Rótulo do botão de download: "Baixar análise" (status 9) ou
     *  "Baixar resultado" (status 6/7). */
    labelDownload?: string
    /** Exibe o "Reprocessar OS". No status 9 é sempre true; nos status 6/7 a
     *  regra de produção é mostrar só quando não há arquivo processado. */
    mostrarReprocessar?: boolean
    /**
     * Motivo para bloquear o reprocessamento (ex: sem cliente no filtro global).
     * O download continua liberado: só a gravação é barrada.
     */
    motivo_bloqueio?: string
}

/** Frase de confirmação do reprocessamento (varia se o calcário mudou). */
function fraseReprocessar(cod_calcario: number, cod_propriedade: number, nome: string, talhao: string) {
    if (cod_calcario !== cod_propriedade) {
        return 'O calcário atual é diferente do processado, deseja realmente reprocessar a OS?'
    }
    return `Deseja reprocessar a OS da ${nome} - ${talhao}?`
}

/**
 * Ações de "Baixar análise" e "Reprocessar OS".
 * Autocontido: recebe os dados brutos e executa tudo internamente (via hooks
 * de mutation do service), sem depender de callbacks/meta do módulo.
 */
export const DownloadReprocessarOS: React.FC<Props> = ({
    arquivo_processado_url,
    cod,
    cod_cliente,
    propriedade_nome,
    talhao_nome,
    cod_calcario,
    cod_calcario_propriedade,
    refetch,
    labelDownload = 'Baixar análise',
    mostrarReprocessar = true,
    motivo_bloqueio,
}) => {
    const [confirmarReprocessar, setConfirmarReprocessar] = useState(false)
    const { mutate_download, carregando_download } = useDownloadResultado()
    const { mutate_reprocessar, carregando_reprocessar } = useReprocessarOs()

    function confirmarReprocessarOs() {
        mutate_reprocessar(
            { cod, cod_cliente, refetch },
            { onSuccess: () => setConfirmarReprocessar(false) }
        )
    }

    return (
        <Box>
            <ButtonCustom
                onClick={() => mutate_download({ arquivo_processado_url, cod })}
                icon={<FontAwesomeIcon icon={faDownload} />}
                loading={carregando_download}
            >
                {labelDownload}
            </ButtonCustom>
            <Render condition={mostrarReprocessar}>
                <Tooltip title={motivo_bloqueio}><span>
                    <ButtonCustom
                        danger
                        type="secondary"
                        onClick={() => setConfirmarReprocessar(true)}
                        icon={<FontAwesomeIcon icon={faRotate} />}
                        loading={carregando_reprocessar}
                        disabled={!!motivo_bloqueio}
                    >
                        Reprocessar OS
                    </ButtonCustom>
                </span></Tooltip>
            </Render>

            <Modal
                open={confirmarReprocessar}
                footer={null}
                closeIcon={false}
                zIndex={9999}
                onCancel={() => setConfirmarReprocessar(false)}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    <Warning type='warning'>
                        {fraseReprocessar(cod_calcario, cod_calcario_propriedade, propriedade_nome, talhao_nome)}
                    </Warning>

                    <div style={{ display: 'flex', gap: 10 }}>
                        <ButtonCustom
                            danger
                            type='secondary'
                            onClick={() => setConfirmarReprocessar(false)}
                            icon={<FontAwesomeIcon icon={faXmark} />}
                        >
                            Não
                        </ButtonCustom>
                        <ButtonCustom
                            onClick={confirmarReprocessarOs}
                            icon={<FontAwesomeIcon icon={faRotate} />}
                            loading={carregando_reprocessar}
                        >
                            Sim
                        </ButtonCustom>
                    </div>
                </div>
            </Modal>
        </Box>
    )
}
